import { CommissionModel } from '../../interfaces/commissionModel';
import { getAllJsonApiPages } from '../../utils/jsonApi';

// Large enough that an agent's commission models come back in one request.
// Any extra pages are still fetched by getAllJsonApiPages.
const COMMISSION_MODELS_PAGE_SIZE = 100;

/**
 * Fetches the commission models an agent has accepted from the internal
 * JSON:API endpoint, as the internal labels /deals/agent used to return in
 * `commission_models_accepted`.
 */
export const fetchAgentCommissionModels = async (
  agentId: string | number,
): Promise<string[]> => {
  const models = await getAllJsonApiPages<CommissionModel>(
    `/internal/v1/agents/${agentId}/commission-models/`,
    {
      params: { 'page[size]': COMMISSION_MODELS_PAGE_SIZE },
      numericIds: true,
    },
  );
  return models.map(({ internal_label }) => internal_label);
};
